// Import System requirements
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'

import {
  sync
} from 'vuex-router-sync'
import routes from './routes'
import store from './store'
import VTooltip from 'v-tooltip'

import LZString from 'lz-string'
var Chance = require('chance')()
var iziToast = require("izitoast")

// Import Helpers for filters
import {
  domain,
  count,
  prettyDate,
  pluralize
} from './filters'

//import commons
import jed_translate from 'jed_translate'

//import mixins
import sidebar_resize_mixin from './mixins/sidebar_resize_mixin'
import support_sidebar_resize_mixin from './mixins/support_sidebar_resize_mixin'
import direct_tree_navigation from './mixins/direct_tree_navigation'
import jquery_validator_mixin from './mixins/jquery_validator_mixin'
import help_mode_handler_mixin from './mixins/help_mode_handler_mixin';
import icons_mixin from './mixins/icons_mixin';
import shopcart_registry_mixin from './mixins/shopcart_registry_mixin';
import download_mixin from './mixins/download_mixin';
import loki_db_loader from './mixins/loki_db_loader';
import registry_proxy_mixin from './mixins/registry_proxy_mixin';
import notification_mixin from './mixins/notification_mixin';
import base64Tool_mixin from './mixins/base64Tool_mixin';
import print_manager_mixin from './mixins/print_manager_mixin';

// Import Views - Top level
import AppView from './components/App.vue'

import utils from '../utils/utilities.js'
//CLASSI CUSTOM
import LokiSyncDB from "./LokiSyncDB"
import NotificationManager from "./NotificationManager"
var CatalogCore = require("catalog_core").Catalog
import { eventBus } from "./eventbus.js";

import bowser from '../static/js/bowser.js'

var async = require("async")

// Import Install and register helper items
Vue.filter('count', count)
Vue.filter('domain', domain)
Vue.filter('prettyDate', prettyDate)
Vue.filter('pluralize', pluralize)

Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(VTooltip)

Vue.http.headers.common['Access-Control-Allow-Origin'] = '*://*/*';

// Routing logic
var router = new VueRouter({
  routes: routes,
  mode: 'history',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || {
      x: 0,
      y: 0
    }
  }
})

import LokiOverride from "./lokiOverride.js"
LokiOverride.override();

import languages from '../static/js/lang_main.js'
//________________________________________________________________________________________________________________ 

// Some middleware to help us ensure the user is authenticated.

sync(store, router)

//_________________________________________________________________________________________________________________

if (sessionStorage.getItem("idUtente") == null) {
  window.location.href = "login.html";
} else {
  Object.defineProperty(Vue.prototype, '$Chance', {
    get() {
      return this.$root.Chance
    }
  })
  Object.defineProperty(Vue.prototype, '$Jed', {
    get() {
      return this.$root.Jed
    }
  })
  Object.defineProperty(Vue.prototype, '$Behaviors', {
    get() {
      return this.$root.token.behaviors
    }
  })
  Object.defineProperty(Vue.prototype, '$Components', {
    get() {
      return this.$root.token.components
    }
  })
  Object.defineProperty(Vue.prototype, '$Configs', {
    get() {
      return this.$root.token;
    }
  })
  Object.defineProperty(Vue.prototype, '$Sync', {
    get() {
      return this.$root.syncManager;
    }
  })

  //________________________________________________________________________________________________________________
  var connectivity = false;
  var currentURL = window.location.href;
  var name;
  if (utils.getParameterByName('token', currentURL)) {
    name = utils.getParameterByName('token', currentURL)
  }

  var language = {
    lang: "",
    flag: ""
  }
  language.lang = utils.getParameterByName('lang', currentURL);
  if (name == null) {
    name = localStorage.getItem("token");
  } else {
    localStorage.setItem("token", name);
  }
  if (language.lang == null) {
    language.lang = localStorage.getItem("lang");
  } else {
    localStorage.setItem("lang", language.lang);
  }

  var token,
    xobj = new XMLHttpRequest();
  xobj.overrideMimeType("application/json");
  xobj.open('GET', front_end_configs.router_url + '/' + name + '.json', false);
  if (navigator.onLine) { //se sono online imposto di non salvare la risorsa in cache perchè la prenderò "fresca" dal server
    xobj.setRequestHeader("Cache-Control", 'max-age=0');
  }
  xobj.onreadystatechange = function () {
    if (xobj.readyState == 4 && xobj.status == "200") {
      connectivity = true;
      var res = xobj.responseText;
      var parseRes = JSON.parse(res);
      if (!parseRes.error) { //se ho trovato il file token
        token = parseRes
        console.log('TOKEN: ', token);
      } else {
        alert('Error in getting token');
      }
    }
  };

  try {
    xobj.send();
  } catch (e) {
    alert('Server is offline. Token not retrieved.')
    alert(e)
    token = null;
  }

  Vue.http.headers.common["Authorization"] = localStorage.getItem("token")

  //________________________________________________________________________________________________________________

  var xobj = new XMLHttpRequest();
  xobj.open('GET', '/' + front_end_configs.versions.jsonTranslations[language.lang], false);
  xobj.setRequestHeader("Access-Control-Allow-Origin", '*://*/*');
  xobj.setRequestHeader("Content-Type", "application/json");
  xobj.onreadystatechange = function () {
    var langs;
    if (xobj.readyState == 4 && xobj.status == "200") {
      langs = xobj.responseText;
      langs = JSON.parse(langs);
      if (langs) {
        jed_translate.init(langs)
      }
    }
  };
  try {
    xobj.send();
  } catch (e) {
    alert('Problem in getting the file of the translations.')
    alert(e)
  }
  language.flag = language.lang ? languages.languages.find( l =>  l.cod == language.lang ).icon : '';

  //________________________________________________________________________________________________________________    

  if (token == null) {
    alert('Token is null. Unable to proceed further. Redirecting to login page...')
    window.location.href = '/login.html';
  }

  //token.behaviors.chooseRootNode = false;
  //token.behaviors.machineIdMustExists = false;

  /*TOKEN TEST OVERRIDE*/
  /*
  token.behaviors.side = 'sx';
  token.behaviors.expanded = true;
  token.behaviors.loadFirstCatalog = true;
  token.behaviors.loadCatalogIfOne = true;
  token.behaviors.chooseRootNode = true;
  token.behaviors.requestUpdateReference = true;
  token.behaviors.machineIdMustExists = false; //; false  true
  token.behaviors.requestMachineModel = false;
  token.behaviors.updatesReference = 'date'; //; 'date' 'serial'
  token.behaviors.presetProductionDate = true;
  token.behaviors.machineIdValidationExp = '';
  token.behaviors.modelIdValidationExp = '';
  token.behaviors.deleteUnsavedOrders = false;
  token.behaviors.machineRegistrationAllowed = true;
  token.behaviors.preferencesAfterLogin = false;
  //token.behaviors.hotspotLoadLinkedNode
  token.behaviors["focusByPosition"] = true;
  */
  //dichiaro la funzione che userò per reperire il parametro di focus
  token.behaviors.focusBy = function () {
    return token.behaviors["focusByPosition"] ? 'pos' : 'sid';
  }

  var license_id = token.idAgente && token.idAgente != "null" ? token.idAgente : token.idCliente 
  //________________________________________________________________________________________________________________    
  // Start out app!
  // eslint-disable-next-line no-new
  new Vue({
    el: '#root',
    router: router,
    store: store,
    mixins: [
      sidebar_resize_mixin, //mixin per le gestione della sidebar ridimensionabile
      support_sidebar_resize_mixin,
      direct_tree_navigation,
      jquery_validator_mixin,
      help_mode_handler_mixin,
      icons_mixin,
      shopcart_registry_mixin,
      loki_db_loader,
      registry_proxy_mixin,
      download_mixin,
      notification_mixin,
      base64Tool_mixin,
      print_manager_mixin
    ],
    render: h => h(AppView),
    created: function () {
      try {
        if (this.front_end_configs.graphics.thumb && this.front_end_configs.graphics.print && this.front_end_configs.graphics.display) {
          this.graphics = this.front_end_configs.graphics
        } else {
          console.log("Using default mapping")
        }
      } catch (err) {
        console.log("err checking graphics: ", err)
      }
      console.log(this.graphics);

      //verifico modalità BCS integrazione ecommerce
      if(this.$Configs.categoriaCliente!='Cliente distributore'){
        //modalità attiva solo per le categorie "Cliente diretto" o "Distributore"
        if(this.$Configs.ecp.tipoIntegrazione && this.$Configs.ecp.tipoIntegrazione.includes("Invia prodotti nel carrello")){
          //è attiva un'interfaccia con tipo integrazione = invia prodotti nel carrello
          this.ecIntegrationActive = true
        }else if(this.$Configs.ecp.tipoIntegrazione && this.$Configs.ecp.tipoIntegrazione.includes("vai a pagina e-commerce")){
          //è attiva un'interfaccia con tipo integrazione = vai a pagina e-commerce
          //questo caso "vuoto" serve per non far bloccare il carrello altrimenti andrebbe nel prossimo caso e con il behaviour verrebbe nascosto 
          console.log("do nothing")
        }else if(this.$Behaviors.blockCartIfNoEcidForDistributorOrDirectClient){
          //non posso fare ordini se non è attiva l'interfaccia ecommerce
          this.blockCart = true
        }
      } 
    },
    data() {
      return {
        // plugins references
        Chance: Chance,
        Jed: jed_translate,
        // microservices router address
        msPath: front_end_configs.router_url,
        front_end_configs: front_end_configs,
        registry: registry,
        graphics: {
          display: {
            ext: "svgz",
            pubdir: "dsp"
          },
          print: {
            ext: "png",
            pubdir: "pnt"
          },
          thumb: {
            ext: "jpg",
            suffix: "_tn",
            pubdir: "tn"
          }
        },

        lang: language,
        //filtro validità
        validity: null,
        active_tree_item: {},
        active_tree_path: null,
        //riferimento al catalogo radice, da passare al ms di catalogo
        root_index: null,
        //id del catalogo mostrato nell'albero come radice,
        //può essere un nodo figlio di root_index
        index_as_root: null,
        //referenzio anche il nome del file di catalogo corrente
        root_filename: null,
        model_of_cat: null,
        token: token,
        //vedi App.vue per caricamento
        dbRegistry: null,
        dbServRegistry: null,
        dbCatalog: null,

        commandSet: new CatalogCore(),
        notificationManager: new NotificationManager(this),
        syncManager: new LokiSyncDB(this), // passo il riferimento all'istanza di vue js per potervi accedere nella classe 
        // license_id 1-1 INDEXED db TODO: ORA 1-1 con CLIENT ID? giusto così?
        dataReferencesDbName: license_id,
        dataReferences: null,
        dbModels: null,
        clientSelected: null, //id del cliente selezionato nel wizard
        preferences: {},

        WINDOW_HEIGHT: $(window).height(),
        connectivity: connectivity,
        brandObj: null,
        ids: null,
        showNotific: false,
        richiestaImpiego: null,
        richiestaImpiegoPerm: null,
        catalog_icon: '',
        fsinstances:[],
        executingSync: false,
        showOnlyImg: false,
        toShow: [],
        prod_icons: {},
        doc_types: {},
        fromViewer: false,
        blockedGridView: false,
        ecIntegrationActive: false,
        blockCart: false
      }
    },
    watch: {
      active_tree_path: function () {
        localStorage.setItem("active_path", JSON.stringify(this.active_tree_path));
      },
      executingSync: function(){
        eventBus.$emit('syncCompleted')
      }
    },
    methods: {
      microservice: function (action, body) {
        var json = action,
            vm = this;
        
        if(json.params){
          if (localStorage.getItem("token")) {
            json.params.token = localStorage.getItem("token")
          }
          
          if(!vm.preferences.useOffline){
            json.params.useOnline = true;
          }
          if (json.role == "catalog" || json.role == "generator" || json.role == "data") {
            //se non specifico un indice catalogo, uso quello 'attivo' come default
            if (json.params.catalog == null) {
              json.params.catalog = this.root_index;
            }
            if (this.validity != null) {
              var validityObj = {
                value: this.validity,
                upReference: this.$Behaviors.updatesReference
              }
              sessionStorage.setItem("validity", JSON.stringify(validityObj))
              json.params.validity = validityObj;
            } else { //quando ricarico la pagina validity è null quindi la prendo dal sessionStorage
              var val = sessionStorage.getItem("validity")
              json.params.validity = JSON.parse(val)
            }
            //console.log('VALIDITY: ', json.params.validity)

            if (this.token.idCliente != null) {
              json.params.idCliente = this.token.idCliente;
            }
            if (this.token.categoriaCliente && this.token.idClienteDistributore && this.token.categoriaCliente == 'Cliente distributore') {
              json.params.idClienteDistributore = this.token.idClienteDistributore;
            }
            if(this.clientSelected){
              json.params.idCliente = this.clientSelected
            }else if (this.token.idAgente != null && this.token.idAgente != "null") {
              json.params.idAgente = this.token.idAgente;
            }
            //TODO: gestire stato ordine attivo
            json.params.priceFlags = {
              statoOrdine: "Standard",
              digits: 2,
              behav: "round" // round, ceil, floor
            }
            if (this.token.registryCliente != null) { // && this.token.registryCliente != "null"
              json.params.registry = this.token.registryCliente;
              if (this.token.idAgente != "null") {
                json.params.agid = this.token.idAgente;
                json.params.cliid = localStorage.getItem("listaClienti");
              } else {
                json.params.cliid = this.token.idCliente
              }
              json.params.stv = front_end_configs.struct_vers;
            }

            json.params.lang = this.token.siglaLingua;
            json.params.defLang = this.token.defaultLang ? this.token.defaultLang : 'ITA';
          }

          if (this.token.registryCliente != null) { //&& this.token.registryCliente != "null"
            json.params.registry = this.token.registryCliente
          }

          if (this.token.modelsDb != null ) { //&& this.token.modelsDb != "null"
            json.params.models = this.token.modelsDb
          }
        }

        // ___________ START PROXY ___________ json.cmd != "SearchByFather" && json.cmd != "SearchById" && json.cmd != "GetProdByCriteria"//
        if (navigator.onLine) {
          // --- ONLINE ---
          // console.log("ONLINE")
          if (json.role == "catalog" || json.role == "generator" || json.role == "search") {

            json.params.ldb = [{
              type: "registry",
              name: json.params.registry
            }, {
              type: "catalog",
              name:  this.root_filename,
              id: this.root_index
            }]
            json.params.catalog = null;
            json.params.registry = null;

            /*
            json.params.registry = json.params.registry;
            json.params.catalog_filename = this.root_filename;
            */
          }

          
          // console.log(json)
          // MS PATH PREFERENCE PROXY OVERRIDE
          var postargs = {
            "Content-Type": "application/json"
          }
          
          if(json=='dataUpload'){ //l'azione è caricamento file
            postargs['Content-Type'] = "multipart/form-data;boundary=----"+this.create_UUID()+"----" //setto i giusti headers
            json = body //imposto il body nella variabile json così non devo modificare la chiamata $http.post
          }

          var st = json.serviceType ? json.serviceType : 'front-end-server'
          if(front_end_configs && front_end_configs.reqTimeout && front_end_configs.reqTimeout[st+"."+json.role+"."+json.cmd]){
            postargs['timeout'] = front_end_configs.reqTimeout[st+"."+json.role+"."+json.cmd]
          }else{
            if(json.cmd == 'GetProdByCriteria'){ //il cmd della ricerca necessita del timeout, se non l'ho trovato faccio delle stampe per verificare la situazione
              try{
                console.log(front_end_configs)
                console.log(front_end_configs.reqTimeout)
                console.log(front_end_configs.reqTimeout[st+"."+json.role+"."+json.cmd])
              }catch(e){console.log(e)}
            }
          }
          return this.$http.post(this.msPath, json, postargs).then(null, error => {
            if(error.status == '403'){ //la richiesta non è autorizzata
              eventBus.$emit('alert', {
                message: vm.$Jed.firstUpperTranslate("Request not authorized. Redirecting to login", null),
                type: "error",
                action: 'logoutFromApp'
              })
            }else if(error.status == '0'){ //la richiesta è andata fuori timeout
              if(json.cmd == 'GetProdByCriteria'){
                eventBus.$emit('no_search_results');
                eventBus.$emit('no_model_results');
                eventBus.$emit('no_mark_results');
                eventBus.$emit('no_merch_results');
                eventBus.$emit('alert', {
                    message: vm.$Jed.firstUpperTranslate("Request timed out. Try to do a more specific search.", null), 
                    type: "warning",
                    action: ''
                })
              }else{
                eventBus.$emit('alert', {
                  message: vm.$Jed.firstUpperTranslate("Request timed out. Retry.", null)+ "<br> <h5>Details: " + json.role + "." + json.cmd + "</h5>",  
                  type: "warning",
                  action: ''
                })
              } 
            }else{ //errori di altro tipo, scatenano azioni definite in front_end_configs.js e gestite qui
              var custom = front_end_configs.cmdErrActions.custom[st+"."+json.role+"."+json.cmd],
                  act = custom ? custom : front_end_configs.cmdErrActions.default;
              if(act == 'none'){

              }else if(act == 'dialog'){
                var msg = error.body.error ? error.body.error : error.status && error.statusText ? error.status +' - '+error.statusText : error
                console.log(msg)
                if(msg == "timeout for search"){
                  eventBus.$emit('alert', {
                      message: vm.$Jed.firstUpperTranslate("Request timed out. Try to do a more specific search.", null), 
                      type: "warning",
                      action: ''
                  })
                } else { 
                  eventBus.$emit('alert', {
                    message: vm.$Jed.firstUpperTranslate("Request went wrong", null)+ "<br> <h5>Details: " + json.role + "." + json.cmd + " - " + msg +'</h5>', 
                    type: "error",
                    action: ''
                  })

                }
                        
               
              }else if(act == 'quit'){
                vm.logout()
              }
            }
          });
        } else {
          // --- OFFLINE ---
          console.log("OFFLINE")

          if (json.role == "catalog") {

            json.params.registry = this.dbServRegistry;
            json.params.catalog = this.dbCatalog;
            console.log(json.params)
            var vm = this;
            // dato che le callback dell'applicativo si aspettano una response http, creo una promise che ha il solo scopo di formattare la risposta con body: res
            return new Promise(function (resolve, reject) {
              vm.$nextTick(function () {
                console.log("starting master promise")
                var pending = vm.commandSet[json.cmd](json.params);
                // la chiamata al comando ritorna a sua volta una promise, per gestire anche quelli che eseguono codice asincrono (solo GetProdByCriteria)
                pending.then((res) => {
                  console.log("resolved master promise")
                  resolve({
                    body: res
                  })
                }, (err) => {
                  console.log("rejected master promise")
                  reject(err)
                })
              })
            })
          }

        }
      },
      getGraphic: function (fn, type, encode) {
        var t = this.graphics[type];
        var path = this.msPath + '/' + t.pubdir + '/'
        if (encode) {
          path += encodeURIComponent(fn)
        } else {
          path += fn;
        }
        if (t.suffix) {
          path += t.suffix;
        }
        path += ("." + t.ext);
        return path;
      },
      manualSync: function () {
        this.simpleNotification("info", {
          title: "",
          message: this.$Jed.firstUpperTranslate("launch remote sync", null)
        })
        this.$Sync.remoteSyncRegistry().then(() => {
          console.log("____ SYNC RESOLVED ____")
          this.simpleNotification("success", {
            title: "",
            message: this.$Jed.firstUpperTranslate("remote sync", null) + ' ' + this.$Jed.translate("ended succesfully", null)
          })
        });
      },
      parseValidity: function (toParse) {
        var array = [];
        var filterValidity = this.$Behaviors.updatesReference == "serial" ? this.serialValidity : this.dateValidity;

        if (toParse.length > 0) {

          array = toParse.filter(filterValidity);
          return array;
        } else {
          return filterValidity(toParse);
        }
      },
      serialValidity: function (obj) {
        if (obj.miv == null || obj.miv < this.validity) {
          if (obj.mfv == null || obj.mfv > this.validity) {
            return true;
          }
        }
        return false;
      },
      dateValidity: function (obj) {
        try {
          if (obj.div == null || Date.parse(obj.div) < this.validity) {
            if (obj.dfv == null || Date.parse(obj.dfv) > this.validity) {
              return true;
            }
          }
        } catch (err) {
          console.log(err);
        }
        return false;
      },
      setItem: function (name, item) {
        try {
          if (Number.isInteger(item)) {
            item = item.toString();
          }
          sessionStorage.setItem(name, LZString.compressToUTF16(item));
        } catch (err) {
          sessionStorage.setItem(name, item);
        }
      },
      getItem: function (name) {
        try {
          var x = LZString.decompressFromUTF16(sessionStorage.getItem(name));
          return x == "" ? null : x;
        } catch (err) {
          return sessionStorage.getItem(name);
        }
      },
      encode: function (s) {
        try {
          return this.Base64.encode(s) //faccio riferimento al mixin base64Tool
        } catch (err) {
          console.log(err)
          return null
        }
      },
      decode: function (s) {
        try {
          return this.Base64.decode(s) //faccio riferimento al mixin base64Tool
        } catch (err) {
          console.log(err)
          return null
        }
      },
      openSidebar: function () {
        var is_open = $("body").hasClass("sidebar-collapse")
        if (is_open) {
          $("body").removeClass("sidebar-collapse");
        }
      },
      closeSidebar: function () {
        var is_open = $("body").hasClass("sidebar-collapse")
        if (!is_open) {
          $("body").addClass("sidebar-collapse");
        }
      },
      getRegistryIdentifier: function () {
        var registryIdentifier = [];
        if (this.token.licenseId) {
          registryIdentifier.push(this.token.licenseId)
        }
        if (this.token.idCliente) {
          registryIdentifier.push(this.token.idCliente)
        } else if (this.token.idAgente) {
          registryIdentifier.push(this.token.idAgente)
        }
        registryIdentifier = registryIdentifier.join("-");
        console.log("Using identifier " + registryIdentifier);
        return registryIdentifier;
      },
      _SYNC_TEST_UNIT() {
        /*
        var reg = this.dbRegistry;

        var update = reg.getCollection("orders").find({
          "id": 3370
        })
        update[0].osi = 4
        reg.getCollection("orders").update(update);
        
        
        reg.getCollection("addresses").insert({
          id: 15211522,
          add: "Viale Zauli 25",
          cap: "47013",
          cel: "",
          cid: "015001",
          cii: "",
          cld: "",
          con: "Lorenzo Foca",
          dea: 0,
          fax: "",
          loc: "Dovadolaux",
          maa: 0,
          mai: "",
          mac: "015001",
          mdt: "2019-05-16T13:44:00.732Z",
          nat: "France",
          pid: "",
          pro: "pyrenees atlantique",
          reg: "Pyrennees Atlantique",
          sti: "",
          tel: ""
        })

        
        var update2 = reg.getCollection("orderItems").find({
          "id": 7730
        })
        update2[0].unp = 4.00
        reg.getCollection("orderItems").update(update2);

        reg.getCollection("orderItems").insert({
            cid: "013115",
            ibu: true,
            id: 1521,
            ide: "76",
            mdt: Date.now(),
            mqt: 1,
            oid: 3544,
            pid: "E.01.01.L10001_0",
            qty: 1,
            sta: "Da quotare",
            unp: 1.00,
            ulp: 100,
            uni: "Pezzi"
          }) 
        */

        this.manualSync();
      },
      setCustomCss: function(){
        if (this.brandObj && this.brandObj.css) { 
          var templatecss = "/../static/css/";
          this.brandObj.css = templatecss + this.brandObj.css;
          var cssId = 'customCss';
          if (!document.getElementById(cssId)) { //se il css non è già presente
            var head = document.getElementsByTagName('head')[0];
            var link = document.createElement('link');
            link.id = cssId;
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.href = this.brandObj.css;
            head.appendChild(link);
          } else {
            console.log(cssId + ' file already loaded');
          }
        }
      },
      logout() {
        console.log('MAIN LOGOUT')
        const me = this
        me.microservice({
                role: "authentication",
                cmd: "Logout",
                params: {
                    token: window.localStorage.getItem('token')
                }
            }).then(()=>{
              me.redirectToLogin();
            })
            .catch((e)=>{
              console.log(e)
              me.redirectToLogin();
            })
      },
      redirectToLogin(){
        var me = this;
        me.$store.commit('SET_USER', null)
        me.$store.commit('SET_TOKEN', null)

        if (window.localStorage) {
            window.localStorage.setItem('user', null)
            window.localStorage.setItem('token', null)
        }

        me.$router.push('/login')
        window.location.href = '/login.html';
      },
      create_UUID: function(){
          var dt = new Date().getTime();
          var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
              var r = (dt + Math.random()*16)%16 | 0;
              dt = Math.floor(dt/16);
              return (c=='x' ? r :(r&0x3|0x8)).toString(16);
          });
          return uuid;
      },
      styleSupportSidebarIcons(){
        if(!this.blockedGridView){
          if(this.showOnlyImg){
            document.getElementById('switch_table').style.cursor = 'not-allowed'
            document.getElementById('switch_detail').style.cursor = 'not-allowed'
            document.getElementById('switch_grid').style.cursor = 'not-allowed' 
          }else{
            try{
              if(document.getElementById('switch_table') && document.getElementById('switch_detail') && document.getElementById('switch_grid')){
                document.getElementById('switch_table').style.cursor = 'context-menu'
                document.getElementById('switch_detail').style.cursor = 'context-menu'
                document.getElementById('switch_grid').style.cursor = 'context-menu'
              }
            }catch(e){
              console.log(e)
            }
          }
        }
      }
    }
  })
}

// Check local storage to handle refreshes
if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null'
  var localUser = JSON.parse(localUserString)

  if (localUser && store.state.user !== localUser) {
    store.commit('SET_USER', localUser)
    store.commit('SET_TOKEN', window.localStorage.getItem('token'))
  }
}



// WEBPACK FOOTER //
// ./src/main.js